/* eslint-disable react/jsx-pascal-case */
import { Router, Redirect, Route, Switch } from "react-router-dom";
import axios from "axios";
import Home from "../pages/Home/Home";
import Interview from "../pages/Interview/Interview";
import PersonalDetails from "../pages/PersonalDetails/PersonalDetails";
import CompanyProfile from "../pages/CompanyProfile/CompanyProfile";
import AddEmployee from "../pages/AddEmployee/AddEmployee";
import EmpStaff from "../pages/AddEmployee/EmpStaff";
import UploadEmployeepic from "../pages/AddEmployee/UploadEmployeepic/UploadEmployeepic";
import EmpDetails from "../pages/AddEmployee/EmpDetails/EmpDetails";
import EmpHeadShot from "../pages/AddEmployee/EmpHeadShot/EmpHeadShot";
import PostGig from "../pages/GigManagement/PostGig";
// import PerGig from "../pages/GigManagement/PerGig/PerGig";
import ContractGig from "../pages/PostAJob/PostJobForm/ContractGig/ContractGig";
import PerGig from "../pages/PostAJob/PostJobForm/PerGig/PerGig";
import GigDescription from "../pages/GigManagement/GigDescription/GigDescription";
import ViewGigs from "../pages/GigManagement/ViewGigs/ViewGigs";
import ProfileDetail from "../pages/ProfileDetail/ProfileDetail";
import Profession from "../pages/Signup/Profession";
import SuccessScreen from "../pages/Signup/SuccessScreen/SuccessScreen";

import PostaJobBudgetForm from "../pages/PostAJob/PostJobForm/components/jobBudgetForm/JobBudgetForm";

import CompanyDetails from "../pages/CompanyProfile/CompanyDetails/CompanyDetails";
import SignUpLogin from "../pages/Auth/components/SignUpLogin";
// import Resume3d from "../pages/3dResume/3dResume";
import PhotoManager from "../pages/CompanyProfile/OurCulture/CompanyCulturePhotos/PhotoManager";
import MarqueeAlbum from "../pages/CompanyProfile/MarqueeAlbum/Marquee";
import AuthSuccess from "../pages/Auth/components/AuthSuccess";
import Followers from "../pages/CompanyProfile/Followers/Followers";
import Views from "../pages/CompanyProfile/Views/Views";
import TalentEmployer from "../pages/Signup/Signup-Steps/StepOne/TalentEmployer";
import AboutCompany from "../pages/CompanyProfile/About/About";
import SearchGigs from "../pages/SearchSkillListing/SearchGigs";
import CompanyLogo from "../pages/AddEmployee/CompanyLogo/CompanyLogo";
import Chat from "../pages/Chat/Chat";
import React from "react";
import Auth from "../pages/Auth/Auth";
import LostPassword from "../pages/Auth/components/LostPassword";
import LinkedInCheck from "../pages/Auth/components/LinkedInCheck";
import TermsOfServices from "../pages/Auth/components/TermsOfServices";
import history from "./history";
import JobListing from "../pages/JobListing/JobListing";
import CandidateSkillListing from "../pages/SkillListing/CandidateSkillListing/CandidateSKillLisitng";
import InterviewListing from "../pages/Interview/InterviewListing/InterviewListing";
//import JobDetail from "../pages/JobListing/JobDetail/JobDetail";

import JobDetail from "../pages/JobListing/JobDetail/JobDetail";

import SkillMatches from "../pages/SkillMatches/MyMatches";
import PostaJob from "../pages/PostAJob/PostJobForm/components/formSecondPart/formSecondPart";
import JobTemplate from "../pages/PostAJob/jobTemplates/jobTemplates";
import EmployerProfile from "../pages/PostAJob/EmployerProfile/EmployerDashboard";
import JobType from "../pages/Signup/JobType/JobType";
import Resume3d from "../pages/3dResume/3dResume";
import MyFavorites from "../pages/My Favorites/MyFavorites";
import ManageTimeSheet from "../pages/ManageTimeSheet/TimesheetList";
import TimesheetDetails from "../pages/ManageTimeSheet/TimesheetDetails/TimesheetDetails";
import Payment from "../pages/Payment/Payment";
import ManageSpends from "../pages/Payment/ManageSpends/ManageSpends";
import NotificationPage from "../pages/Notifications/NotificationPage";
import MyTeams from "../pages/My Teams/Myteams";
import SearchCandidateMarket from "../pages/Candidate Marketing/SearchConfig";
import Add_Member from "../pages/My Teams/components/Add Member";
import Activate from "../pages/My Teams/components/Activate";
import Conversation from "../pages/Conversations/Conversations";
import OurCulturePhotos from "../pages/CompanyProfile/OurCulture/CompanyCulturePhotos/ourCulturePhotos";
import MyMatches from "../pages/My Matches/MyMatches";
import ManageCandidate from "../pages/ManageCandidate/ManageCandidate";
import MyProfile from "../pages/My Profile/myProfile";
import Subscriptions from "../pages/Subscriptions/Subscriptions";
import Plans from "../pages/Subscriptions/Plans/Plans";
import FindMatches from "../pages/My Matches/components/Find Matches/FindMatches";
import Ratings from "../pages/Ratings/Ratings";
import SkillListing from "../pages/SkillListing/CandidateSkillListing/CandidateSKillLisitng";
import ScrollToTop from "../components/ScrollToTop";
import { getCookie } from "../shared/helpers";
import { useSelector, useDispatch } from "react-redux";
import { retractBid, userLanded } from "../redux/actions";
import FileContainer from "../components/FileContainer/FilerContainer";
import { useEffect, useState } from "react";
import { LoginRoute } from "./routes";
import PlaceBidCard from "../pages/Conversations/components/ChatCard/components/ReceivedBidsCard/PlaceBidCard";
import PlacedBidModalPage, {
  ApolloWrapper,
} from "../components/PlaceBidModal/PlacedBidModalPage";
import { v4 as uuid } from "uuid";
import { APP_NAME } from "../constants/userTrackingConstants";
import CandidateEmail from "../components/CandidateEmail/CandidateEmail";
import AddCandidateEmail from "../components/AddCandidateEmail/AddCandidateEmail";
import AddCandidateName from "../components/AddCandidateName/AddCandidateName";
import CandidateMobileNumber from "../components/CandidateMobile/CandidateMobileNumber";
import CandidateResume from "../pages/PostAJob/EmployerProfile/components/CandidateResume/CandidateResume";
import GigType from "../components/CandidateGigType/GigType";
import SkillListingTitle from "../components/skilllistingtitle/SkillListingTitle";
import CandidateSkills from "../components/CandidateSkills/CandidateSkills";
import CandidateSalary from "../components/CandidateSalary/CandidateSalary";
import MessageToCandidate from "../components/MessageToCandidate/MessageToCandidate";
import DesiredLocation from "../pages/PostAJob/EmployerProfile/components/DesiredLocation/DesiredLocation";
import StartDate from "../pages/PostAJob/EmployerProfile/components/StartDate/StartDate";
import Invite from "../pages/PostAJob/EmployerProfile/components/InviteTalents/Invite";
import WrappedChooseGigPage from "../components/ChooseGigPage/ChooseGigPage";

export const AppRouter = (props) => {
  const { authToken } = props;
  const dispatch = useDispatch();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const finishProfile = getCookie("finishProfile");
  const { finisProf } = useSelector((state) => state.profileReducer);
  const [ipaddress, setIpaddress] = useState("");

  const MasterProtectedRoute = (props) => {
    return (
      JSON.parse(localStorage.getItem("userProfile"))?.MasterAccountId ==
        null && <Route {...props} />
    );
  };

  useEffect(() => {
    dispatch(
      userLanded({
        uuid: localStorage.getItem("uuid") || uuid(),
        pageType: null,
        event: "USER_LANDED",
        page: null,
        appName: APP_NAME.EMPLOYER,
        url: window.location.href,
      })
    );
  }, []);

  return (
    <div
      className="headerSpaceRouter"
      // aria-details={((!userProfile?.verification?.email && finishProfile=="true") && finisProf) && "unverified-header-space"}
    >
      <Router history={history} basename="/employer">
        <ScrollToTop />
        {/*<Header changeStage={props.shareStage} stage={props.stage} />*/}
        <Switch>
          {/* <Route exact path="/">
            <Home />
          </Route> */}
          <Route exact path="/">
            <AuthSuccess ipAddress={ipaddress} />
          </Route>

          <LoginRoute exact auth={authToken} path={"/interview/schedule"}>
            <Interview />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/personaldetails"}>
            <PersonalDetails />
          </LoginRoute>

          <MasterProtectedRoute
            exact
            path="/companyprofile"
            component={CompanyProfile}
          />
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/addemployee"}
          >
            <AddEmployee />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/empstaff"}
          >
            <EmpStaff />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/editBidPage"}>
            <PlaceBidCard />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/editPlaceBidPage"}>
            <ApolloWrapper />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/uploademployeepic"}>
            <UploadEmployeepic />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myprofile"}>
            <MyProfile />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/CompanyLogo"}>
            <CompanyLogo />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/managecandidate"}>
            <ManageCandidate />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/addemployee/empdetails"}
          >
            <EmpDetails />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/empheadshot"}>
            <EmpHeadShot />
          </LoginRoute>
          {/* <Route exact path={'/post-gig'}>
            <PostGig />
          </Route> */}
          <LoginRoute exact path={"/per-gig"} auth={authToken}>
            <PerGig />
          </LoginRoute>
          {/* <Route path="/messages/:id">
                <Chat />
              </Route> */}
          <LoginRoute exact auth={authToken} path={"/job-type"}>
            <JobType />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/contract-gig"}>
            <ContractGig />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/gig-description"}>
            <GigDescription />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/view-gig"}>
            <ViewGigs />
          </LoginRoute>
          {/* <Route exact path={"/conversations/:id"}> */}
          <LoginRoute exact auth={authToken} path={"/conversations/:id?"}>
            <Conversation />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/resume-3d"}>
            <Resume3d />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/joblisting"}>
            <JobListing />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/mymatches"}>
            <MyMatches />
          </LoginRoute>

          <LoginRoute exact path={"/findmatches/:id"}>
            <FindMatches />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/skillListing"}>
            <SkillListing />
          </LoginRoute>
          <LoginRoute exact path={"/employerdashboard"} auth={authToken}>
            <EmployerProfile />
          </LoginRoute>
          <LoginRoute exact path={"/inviteTalents"} auth={authToken}>
            <Invite />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/jobdetail/:id"}>
            <JobDetail />
          </LoginRoute>

          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/companyculturephotos"}
          >
            <OurCulturePhotos />
          </LoginRoute>
          {/* <LoginRoute exact auth={authToken} path={"/profiledetail/:id"}>
                <ProfileDetail />
              </LoginRoute> */}
          <LoginRoute exact auth={authToken} path={"/employerprofession"}>
            <Profession />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/allset"}>
            <SuccessScreen />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/payment"}>
            <Payment />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/managespends"}>
            <ManageSpends />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/companydetails"}
          >
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/updatecompanydetails"}>
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/companydetails"}>
            <CompanyDetails />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/skillmatches"}>
            <SkillMatches />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob"}>
            <PostGig />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob/secondstep"}>
            <PostaJob />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postjob/budgetform"}>
            <PostaJobBudgetForm />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/ratings"}>
            <Ratings />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/marqueealbum"}>
            <MarqueeAlbum />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/followers"}>
            <Followers />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/followers/:id"}>
            <Followers />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/views"}>
            <Views />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/talentemployer"}>
            <TalentEmployer />
          </LoginRoute>
          <LoginRoute
            exact
            auth={authToken}
            path={"/companyprofile/aboutcompany"}
          >
            <AboutCompany />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams"}>
            <MyTeams />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams/addmember"}>
            <Add_Member />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myteams/activate"}>
            <Activate />
          </LoginRoute>

          <LoginRoute exact auth={authToken} path={"/candidateskilllisting"}>
            <CandidateSkillListing />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/candidatemarketing"}>
            <SearchCandidateMarket />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/view-interviews"}>
            <InterviewListing />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/myfavourites"}>
            <MyFavorites />
          </LoginRoute>
          <LoginRoute exact auth={authToken} path={"/postajob/choosetemplate"}>
            <JobTemplate />
          </LoginRoute>
          <Route exact path={"/timesheet/list"}>
            <ManageTimeSheet />
          </Route>
          <Route exact path={"/timesheet/details"}>
            <TimesheetDetails />
          </Route>
          <LoginRoute auth={authToken} exact path={"/notification"}>
            <NotificationPage />
          </LoginRoute>
          <Route exact path={"/subscriptions-main"}>
            <Subscriptions />
          </Route>
          <Route exact path={"/choose-plan"}>
            <Plans />
          </Route>
          <Route exact path="/terms">
            <TermsOfServices />
          </Route>
          <Route exact path={"/filecontainer"}>
            <FileContainer />
          </Route>
          <Route exact path={"/signup"}>
            <Auth signUp={true} />
          </Route>
          <Route exact path="/auth">
            <AuthSuccess />
          </Route>
          <Route exact path="/query/:searchValue" component={SearchGigs} />
          <Route exact path="/query" component={SearchGigs} />
          <Route exact path="/query/:searchValue" component={SearchGigs} />
          {/* <PublicRoute exact path="/query" component={SearchGigs} /> */}
          <Route exact path={"/profiledetail/:id"} component={ProfileDetail} />
          <LoginRoute exact auth={authToken} path={"/invitedTalent/:id"}>
            <ProfileDetail isInvited={true} />
          </LoginRoute>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={Auth} />
          <Route exact path="/forgot" component={LostPassword} />
          <Route path="/auth" component={AuthSuccess} />
          <Route exact path="/linkcheck" component={LinkedInCheck} />
          <Route exact path="/terms" component={TermsOfServices} />

          {/* <Redirect to="/employerdashboard" /> */}
          {/* <Route exact path="/candidateEmail" component={CandidateEmail} /> */}

          {/* <LoginRoute  auth={authToken} path={"/candidateskilllisting"}>  */}
          <LoginRoute auth={authToken} exact path="/add-candidate-email">
            <AddCandidateEmail />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/add-candidate">
            <AddCandidateEmail isCandidateRoute={true}/>
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/add-candidate-name">
            <AddCandidateName />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-number">
            <CandidateMobileNumber />
          </LoginRoute>
          {/* <Route exact path="/candidateResume" component={CandidateResume} /> */}
          <LoginRoute auth={authToken} exact path="/select-gig-type">
            <GigType />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/gig-title">
            <SkillListingTitle />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-skill">
            <CandidateSkills />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/candidate-salary">
            <CandidateSalary />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/message-candidate">
            <MessageToCandidate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/location">
            <DesiredLocation />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path="/date">
            <StartDate />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/select-gig-type"}>
            <GigType />
          </LoginRoute>
          <LoginRoute auth={authToken} exact path={"/choose-gig"}>
            <WrappedChooseGigPage />
          </LoginRoute>
        </Switch>
      </Router>
    </div>
  );
};
